import { DEVICE_CALIBRATION_PRE_EXPIRATION_WARNING_DAYS } from '@/fleet-configuration/data-fleet/devices-calibrations/devices-calibrations-constants'

export const getCalibrationUserData = state => state.entries.calibration.userData
export const getCalibrationFormData = state => state.entries.calibration.formData
export const getCalibrationFormDataErrors = state => state.entries.calibration.formDataErrors
export const getCalibrationItems = state => state.entries.calibration.calibrationItems
export const getCalibrationSettingSlice = state => state.entries.calibration.setting
export const getCalibrationSettingData = state => state.entries.calibration.setting?.data

// Warning days come from the per-tenant setting; we fall back to the legacy hardcoded value
// until the setting has been fetched so existing call sites stay consistent before hydration.
export const getCalibrationWarningDays = state =>
  state.entries.calibration.setting?.data?.calibrationExpirationWarningDays ??
  DEVICE_CALIBRATION_PRE_EXPIRATION_WARNING_DAYS
